import { TEntity, TLanguage } from 'contexts/app-context/types'

import { useQuery } from '@tanstack/react-query'

import { getFaqAnswerQueryOptions } from './queries/getFaqAnswerQueryOptions'

type UseGetQuestionsDetailsProps = {
  id: string
  language: TLanguage
  userSelectedEntity: TEntity
}

export const useGetFAQAnswer = ({
  id,
  language,
  userSelectedEntity,
}: UseGetQuestionsDetailsProps) => {
  const {
    data: answer,
    isLoading: isAnswerLoading,
    isError: isAnswerError,
    refetch: fetchFAQAnswer,
  } = useQuery({
    ...getFaqAnswerQueryOptions({ id, language, userSelectedEntity }),
    enabled: false,
  })

  return {
    answer,
    isAnswerLoading,
    isAnswerError,
    fetchFAQAnswer,
  }
}
